<template>
    <client-page>
        <page-section class="page-section--first page-section--last page-section--sm">
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">오시는 길</h2>
            </div>
            <div class="tit-wrap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.7934776802185!2d126.83175787640566!3d37.55992922450596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9c65be69a98b%3A0x3d4d0fe99a385916!2z7ISc7Jq47Yq567OE7IucIOqwleyEnOq1rCDrp4jqs6HspJHslZk266GcIDY2!5e0!3m2!1sko!2skr!4v1760668046316!5m2!1sko!2skr" width="100%" height="540" style="border: 0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </div>
            <v-sheet color="grey lighten-5" rounded="xl" class="location-informations">
                <v-row justify="center" align="center">
                    <v-col cols="12" md="6" xl="3">
                        <v-row align="center" class="row--sm">
                            <v-col cols="auto">
                                <v-avatar size="60" outlined>
                                    <v-img src="/images/icon/icon-map.svg" alt="" max-width="22" height="auto" class="rounded-0" />
                                </v-avatar>
                            </v-col>
                            <v-col>
                                <div class="txt txt--dark line-height-15">
                                    <div class="primary--text">리본바이옴</div>
                                    <div>서울특별시 강서구 마곡중앙6로 66, A동 907호</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6" xl="3">
                        <v-row align="center" class="row--sm">
                            <v-col cols="auto">
                                <v-avatar size="60" outlined>
                                    <v-img src="/images/icon/icon-map.svg" alt="" max-width="22" height="auto" class="rounded-0" />
                                </v-avatar>
                            </v-col>
                            <v-col>
                                <div class="txt txt--dark line-height-15">
                                    <div class="primary--text">웰빙엘에스</div>
                                    <div>강원특별자치도 강릉시 과학단지로 24-19</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6" xl="auto">
                        <v-row align="center" class="row--sm">
                            <v-col cols="auto">
                                <v-avatar size="60" outlined>
                                    <v-img src="/images/icon/icon-phone.svg" alt="" max-width="22" height="auto" class="rounded-0" />
                                </v-avatar>
                            </v-col>
                            <v-col>
                                <div class="txt txt--dark line-height-15">
                                    <div>02-6212-2825</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6" xl="auto">
                        <v-row align="center" class="row--sm">
                            <v-col cols="auto">
                                <v-avatar size="60" outlined>
                                    <v-img src="/images/icon/icon-mail.svg" alt="" max-width="22" height="auto" class="rounded-0" />
                                </v-avatar>
                            </v-col>
                            <v-col>
                                <div class="txt txt--dark line-height-15">
                                    <div>rebornbiome@naver.com</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-sheet>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";

export default {
    components: {
        ClientPage,
        PageSection,
    },
};
</script>

<style lang="scss" scoped>
.location-informations {
    padding: 20px;
    .v-avatar {
        border: 1px solid var(--v-grey-lighten3);
    }
}
@media (min-width: 768px) {
    .location-informations {
        padding: 32px;
    }
}
</style>
